export const animationStatesTraverseTest = ({
	buildsignature,
	categoryid,
	createtime,
	desyncdata,
	desyncid,
	screenshot,
	sessionid,
	sku,
	systemconfig,
	type,
	version,
}) => {
	if (desyncdata !== undefined && categoryid !== undefined) {
		if (categoryid.indexOf('asm.py') !== -1) {
			if (desyncdata.indexOf('Exception in Sim Timeline') !== -1 && desyncdata.indexOf('Attempt to traverse between two states') !== -1 && desyncdata.indexOf('no valid path exists') !== -1) {
				return {
					type: 'animationStatesTraverseTest',
					color: 'MediumAquamarine',
					title: 'Animation States Traverse Error',
					text: 'Base game issue with the animations system.',
					description: 'A Sim or object was interrupted while trying to play out an animation. For the most part, you\'re safe to ignore this error.'
				}
			}
		}
	}
}

// EXAMPLE
/*
<root>
    <report>
        <version>2</version>
        <sessionid>2a4b633bc5f8e0f05b561234</sessionid>
        <type>desync</type>
        <sku>ea.maxis.sims4_64.15.pc</sku>
        <createtime>2099-07-23 19:57:35</createtime>
        <buildsignature>Local.Unknown.Unknown.1.99.88.1020-1.200.000.354.Release</buildsignature>
        <categoryid>asm.py:995</categoryid>
        <desyncid>2a4b633bc5f8e0f05b561234</desyncid>
        <systemconfig/>
        <screenshot/>
        <desyncdata>Exception in Sim Timeline: Exception running Element (RuntimeError: ASM :: Book_StartStop (HANDLE :: 45182)&gt;: Attempt to traverse between two states (entry -&gt; exit) where no valid path exists! Actors {'book': (&lt;weakref at 0x00007FF49FED68E8; to 'book_Skill_Parenting_Beginner' at 0x00007FF4B4C48050&gt;, None, &lt;AnimationParticipant.TARGET = 103&gt;), 'x': (&lt;weakref at 0x00007FF4FB448B50; to 'object_sim' at 0x00007FF4BFAEB110&gt;, None, &lt;AnimationParticipant.ACTOR = 101&gt;)} (debug context:  running book_read:6396 on book_Skill_Parenting_Beginner:0x095107d8f2c411fb  (guaranteed)))
Traceback (most recent call last):
  File &quot;T:\InGame\Gameplay\Scripts\Server\scheduling.py&quot;, line 212, in simulate
  File &quot;T:\InGame\Gameplay\Scripts\Server\elements.py&quot;, line 376, in _run
  File &quot;T:\InGame\Gameplay\Scripts\Server\animation\animation_element.py&quot;, line 611, in do_begin
  File &quot;T:\InGame\Gameplay\Scripts\Server\animation\asm.py&quot;, line 995, in request
RuntimeError: ASM :: Book_StartStop (HANDLE :: 45182)&gt;: Attempt to traverse between two states (entry -&gt; exit) where no valid path exists! Actors {'book': (&lt;weakref at 0x00007FF49FED68E8; to 'book_Skill_Parenting_Beginner' at 0x00007FF4B4C48050&gt;, None, &lt;AnimationParticipant.TARGET = 103&gt;), 'x': (&lt;weakref at 0x00007FF4FB448B50; to 'object_sim' at 0x00007FF4BFAEB110&gt;, None, &lt;AnimationParticipant.ACTOR = 101&gt;)} (debug context:  running book_read:6396 on book_Skill_Parenting_Beginner:0x095107d8f2c411fb  (guaranteed))
</desyncdata>
    </report>
</root>
*/


// WEBPACK FOOTER //
// ./src/tests/basegame/animationStatesTraverseTest.js